// extracted by mini-css-extract-plugin
export default {"wrapper":"burger-ingredients_wrapper__76LDc","ingredients":"burger-ingredients_ingredients__5l7jt","cards":"burger-ingredients_cards__8Eu1v"};